import {
  PermissionsPromptAppIcon,
  PermissionsPromptContainer,
  PermissionsPromptContentContainer,
  PermissionsPromptHexagon,
  PermissionsPromptHexagonGlass,
  PermissionsPromptHexagonStroke,
  PermissionsPromptNotificationCard,
  PermissionsPromptText,
  PermissionsPromptTitle,
} from './components';

// ─────────────────────────────────────────────────────────────────────────────

export const PermissionsPrompt = {
  AppIcon: PermissionsPromptAppIcon,
  Container: PermissionsPromptContainer,
  ContentContainer: PermissionsPromptContentContainer,
  Hexagon: PermissionsPromptHexagon,
  HexagonGlass: PermissionsPromptHexagonGlass,
  HexagonStroke: PermissionsPromptHexagonStroke,
  NotificationCard: PermissionsPromptNotificationCard,
  Title: PermissionsPromptTitle,
  Text: PermissionsPromptText,
};
